import React from 'react';
import PropTypes from 'prop-types';

function RadioButton({ options, onChange, value }) {
    const onChangeRadioButton = radioValue => {
        onChange(radioValue);
    };

    const showLabel = showLabel => {
        if (showLabel) {
            return (
                <label className="c-form-field__label u-mb">
                    {options.text}
                </label>
            );
        }
    };

    return (
        <div className="c-form-field__box">
            {showLabel(options.showLabel)}
            <fieldset>
                {options.values.map((optionValue, index) => {
                    return (
                        <span
                            key={index}
                            id={optionValue.id}
                            className={`${
                                options?.block
                                    ? 'u-block u-mb-small'
                                    : 'o-inline-group__item u-ml-none u-mt-small'
                            }`}
                        >
                            <label className="c-radio">
                                <input
                                    disabled={options.disabled}
                                    value={optionValue.value}
                                    checked={optionValue.value === value}
                                    onChange={e =>
                                        onChangeRadioButton(e.target.value)
                                    }
                                    className={
                                        'c-radio__input ' + options.className
                                    }
                                    type="radio"
                                    name={options.name + 'radio-button'}
                                ></input>
                                <span className="c-radio__label">
                                    {' '}
                                    {optionValue.text}{' '}
                                </span>
                            </label>
                        </span>
                    );
                })}
            </fieldset>
        </div>
    );
}

RadioButton.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    options: PropTypes.shape({
        values: PropTypes.array,
        text: PropTypes.string,
        name: PropTypes.string,
        id: PropTypes.string,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        block: PropTypes.bool,
    }).isRequired,
};

export default RadioButton;
